import React from "react"
import SbEditable from "storyblok-react"
import Markdown from "react-markdown"

import { CallToActionAreaConsumer, transformLinkUri } from "gatsby-theme-gba"

const CallToActionAreaEditable = ({ blok }) => {
  let link

  if (blok.link.linktype === "email") {
    link = `mailto:${blok.link.email}`
  } else if (blok.link.linktype === "story") {
    link =
      blok.link.story && blok.link.story.full_slug
        ? blok.link.story.full_slug
        : blok.link.cached_url
  } else {
    link =
      blok.link.url || blok.link.cached_url
        ? blok.link.linktype === "story"
          ? blok.link.cached_url
          : blok.link.url
        : "/home"
  }

  return (
    <SbEditable content={blok}>
      <CallToActionAreaConsumer
        heading={blok.heading || "Headline"}
        subHeading={blok.subHeading || "Your Subheadline"}
        buttonLink={link}
        download={blok.link && blok.link.linktype === "asset"}
        buttonText={blok.linkText}
        linkTarget={blok.linkTarget}
        triggerSearchDialog={blok.triggerSearch}
        currentLanguage={blok.currentLanguage}
        seoLinks={blok.seoLinks}
        mode={blok.mode}
      >
        <Markdown
          source={blok.body}
          transformLinkUri={uri => {
            return transformLinkUri(
              uri,
              "",
              blok.currentLanguage,
              blok.seoLinks
            )
          }}
        />
      </CallToActionAreaConsumer>
    </SbEditable>
  )
}

export default CallToActionAreaEditable
